import {performHttpRequest} from "../http";

export async function getDatTableInfo(domainID, presentationID, formID, data) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/' + domainID + '/presentation/' + presentationID + '/form/' + formID + '/datatable',
        'POST',
        data
    )
}
